<div class="filter-controls-wrapper flex px-4 radius-top-3">
  <div class="filter-bar flex align-center wrap w-100">
    <div *ngIf="includeSearchControl" class="filter-bar__search">
      <app-search-input
        placeholder=" {{ searchPlaceholder ? searchPlaceholder : 'Placeholder.DottedSearch' | translate }} "
        [showSearchActions]="showSearchActions"
        (searchValue)="onSearch($event)"
        [multiple]="multipleSearch"
        [iconPosition]="searchIconPosition"
        [changePlaceholderColor]="true"
        [clearAllValues]="clearAllValues"
        [initialValue]="searchTerm"
      ></app-search-input>
    </div>

    <div class="filter-bar__actions flex align-center">
      <app-filter-button *ngIf="includeFilterButton" [filterNavigationConfig]="filterNavigationConfig"></app-filter-button>

      <span
        class="filter-bar__divider"
        *ngIf="includeFilterButton && (includeDateControl || includePickupDateControl || includePickupDateLabel)"
      ></span>

      <ng-container *ngIf="includePickupDateControl">
        <ng-container *ngTemplateOutlet="dateFilterType"></ng-container>
      </ng-container>

      <ng-container *ngIf="includePickupDateLabel">
        <span class="small text-400 bg-100 pickupdate-label">{{ PickupDateLabel }}</span>
      </ng-container>

      <ng-container *ngIf="includeDateControl">
        <ng-container *ngTemplateOutlet="dateFilter"></ng-container>
      </ng-container>

      <ng-container *ngIf="includeColumnOptions">
        <span class="filter-bar__divider"></span>
        <button mat-button class="text-600 flex align-center px-1" (click)="toggleColumnOptionsMenu()">
          <app-icon name="bold-task" size="xs" class="mr-1 text-400" direction="ltr"></app-icon>
          {{ 'ColumnOptions.ColumnSettings' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="includeExportMenuButton">
        <app-col>
          <button mat-button class="text-primary-200 flex align-center px-1" [matMenuTriggerFor]="menu">
            <app-icon name="bold-export" size="xs" class="mr-1"></app-icon>
            {{'Buttons.Export' | translate}}
          </button>

          <mat-menu #menu="matMenu" (opened)="expanded = true;" (closed)="expanded = false;">
            <button mat-menu-item (click)="handleExportCsv()">
              <span>{{"shipments.AsCSV" | translate}}</span>
            </button>

            <button mat-menu-item (click)="onExportPDF()">{{'shipments.AsPDF' | translate}}</button>
          </mat-menu>
        </app-col>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #dateFilter>
  <div class="date-dropdown col-auto flex align-center" *ngIf="includeDateControl">
    <app-date-range
      size="xs"
      [showIcon]="true"
      [showCustomDateOption]="showCustomDateOption"
      [maxDate]="maxDate"
      [formControl]="dateRangeControl"
    ></app-date-range>
  </div>
</ng-template>

<ng-template #dateFilterType>
  <div class="date-dropdown pickup-date-dropdown" *ngIf="includePickupDateControl">
    <mat-form-field class="dropdown">
      <mat-select
        class="small radius-1"
        hideSingleSelectionIndicator
        (selectionChange)="selectedShipmentDateFilterTypeChanged.emit($event.value)"
        [value]="shipmentDateFilterTypeValue"
      >
        <mat-option class="small" *ngFor="let item of ShipmentDateFilterType | enumToArray" [value]="item.value">
          {{ "Enum.ShipmentDateFilterType." + item.key | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <span class="filter-bar__divider"></span>
</ng-template>

<ng-template #sortByFilter>
  <div class="sort-by col-auto" *ngIf="includeSortByControl">
    <mat-form-field appearance="outline" class="flex row small">
      <p matPrefix class="sort-by-prefix small">{{ "Table.SortByPrefix" | translate }}</p>
      <mat-select class="small" (selectionChange)="onSelectSortBy($event.value)" [value]="sortOptions.MostRecent">
        <mat-option class="small" *ngFor="let item of sortOptions | enumToArray" [value]="item.value">
          {{ "Enum.SortOptions." + item.key | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>

<ng-template #filterButton>
  <app-filter-button
    [isPrimaryColor]="true"
    [popoverTrigger]="popover"
    #popoverTrigger="popoverTrigger"
    size="xs"
    [closeOnClickOutside]="true"
    [position]="position"
  ></app-filter-button>
  <ng-template #popover>
    <div class="popover-container">
      <app-shipment-list-filter (closeFilter)="popoverTrigger.detachOverlay()"></app-shipment-list-filter>
    </div>
  </ng-template>
</ng-template>
